module.exports = __webpack_public_path__ + "static/media/03.28cd1e6a.jpg";